// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"20":"9a7b4cde","33":"df5578a5","40":"db944f49","118":"62943f2f","385":"b6d165f9","463":"501a0fb4","631":"88b086c2","769":"bc92dc80","959":"049e4394"}[chunkId] + ".chunk.css";
};